const { PUBLIC_ROUTES } = require('./routes');

const TOAST_CONFIG = Object.freeze({
  face_analyzer: {
    title: 'Get contour recommendations for your face shape',
    body: 'Learn how to best accentuate your features with AI guidance',
    redirectUrl: PUBLIC_ROUTES.faceContour,
  },
  'face_analyzer/facial_feature': {
    title: 'Get eyeliner recommendations for your eye shape',
    body: 'Learn how to best accentuate your eyes with AI guidance',
    redirectUrl: PUBLIC_ROUTES.eyeliner,
  },
  'makeup_recommendations/eyeliner': {
    title: "Don't know your eye shape?",
    body: 'Try our Eye Shape Analyzer',
    redirectUrl: '/face_analyzer/eye_shape',
  },
  makeup_recommendations: {
    title: 'Get blush recommendations for your face shape',
    body: 'Try our Blush Placement Guides',
    redirectUrl: PUBLIC_ROUTES.blushPlacement,
  },
  'makeup_recommendations/blush_placement': {
    title: 'Get contour recommendations for your face shape',
    body: 'Try our Live Contour Guides',
    redirectUrl: PUBLIC_ROUTES.faceContour,
  },
  face_shape_blog: {
    title: 'Try our free AI Face Shape Analyzer',
    body: 'Just take or upload a selfie to get started',
    redirectUrl: '/face_analyzer',
  },
  contour_blog: {
    title: 'Try our free Contour Guide Filters',
    body: 'Get live recommendations for your face shape',
    redirectUrl: PUBLIC_ROUTES.faceContour,
  },
});

function getToastConfig(page) {
  return TOAST_CONFIG[page] || {
    title: undefined,
    body: undefined,
    redirectUrl: '/',
  };
}

module.exports = {
  getToastConfig,
  TOAST_CONFIG,
};
